import ko from './ko-KR';
import en from './en-US';
import zh from './zh-CN';

export const langAll = ['ko-KR', 'en-US', 'zh-CN'];
export const langWord = {
  'ko-KR':'한국어',
  'en-US':'English',
  'zh-CN':'简体中文'
};

export interface CommonTs {
  logo: string;
  nav: [{[s: string]:[{[s: string]:[{[s: string]:string}]}]}];
  signup: [{[s: string]: string}];
  user: [{[s: string]: string}];
  sitemap: [{[s: string]:[{[s: string]:[{[s: string]:string}]}]}];
  snsNav: {[s: string]:[{[s: string]:string}]};
  address: string;
  copyright: string;
  // nav: {
  //   [s: string]: {[s: string]: {[s: string]: string } }
  // };
};

export interface HomeTs {
  title: string;
};

export interface GuideTs {
  title: string;
  test: string;
  testBtn: string;
};

export interface TestTs {
  test: string;
};

export default {
  'ko-KR': ko,
  'en-US': en,
  'zh-CN': zh,
};


// WEBPACK FOOTER //
// ./src/locales/index.ts